export const COMMON = {
  UNCATEGORIZED: "uncategorized",
};
// Values of approveStatus as the API sends them (user_course_crew.status).
export const APPROVE_STATUS = {
  DECLINED: "decline",
  BUFFER: "pending",
};

export const ROUTES = {
  member: {
    positions: "positions",
    operations: "operations",
    aircraft: "aircraft",
    specializations: "specializations",
    all: "all",
  },
};

export const VALIDATION_MESSAGE = {
  REQUIRED: "Value is required",
  PASSWORDS_DO_NOT_MATCH: "The password confirmation does not match",
  PASSWORD_CONSTRAINTS_ERROR:
    "Passwords must have at least 1 digit(s) and at least 1 upper case letter(s) and contain at least 8 symbols.",
  EMAIL_FORMAT_WRONG: "Please enter valid email address",
  AUTOCOMPLETE_OBJECT: "Please select value from list",
  EMAIL_EXISTS: "Email already exists, please contact support for more info",
};

export const BUFFER_ZONES = [1, 2, 3];

export const DEFAULT_DATE_FORMAT = "DD.MM.YYYY";
export const DEFAULT_DATE_TIME_FORMAT = "DD.MM.YYYY HH:mm";

export const ROLE_CODES = {
  TRAINER: "trainer",
  INSTRUCTOR: "instructor",
  ASSESSOR: "assessor",
  CHECKER: "checker",
  NOMINATED_PERSON_CREW_TRAINING: "nominated_person_crew_training",
  NOMINATED_PERSON_GROUND_OPERATION: "nominated_person_ground_operation",
  COMPANY_LMS_MANAGER: "company_lms_manager",
};

export const COMPUTED_ROLES = {
  CREW_ADMIN: "crew_admin", // Computed from crew.admin flag only
  SUPER_ADMIN: "super_admin", // Computed from user.sa flag
};

export const PERMISSIONS = {
  SUPER_USER: "super_user",
  SEE_TRAINING_DATA: "see_training_data_of_crew_members",
  BUY_COURSE_FOR_CREW_MEMBERS: "buy_courses_for_crew_members",
  CONFIGURE_COURSES: "configure_courses",
  CONFIGURE_AIRCRAFT: "configure_aircrafts",
  APPROVE_CERTIFICATES: "approve_extern_certificates",
  BULK_UPLOAD_CERTIFICATES: "bulk_upload_certificates",
  CONFIGURE_ROLES: "configure_roles_and_permissions",
  CONFIGURE_COMPANY_LMS_COURSE: "configure_company_lms_course",
  CONFIGURE_COMPANY_CUSTOM_COURSES: "configure_company_custom_courses",
  VIEW_ORDERS: "order_read",
  MANAGE_AIRCRAFT_OPERATIONS: "manage_aircraft_operations",
};
